
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-05-04-r3f-inverted-stencil-buffer",
      function () {
        return require("private-next-pages/blogs/2025-05-04-r3f-inverted-stencil-buffer/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-05-04-r3f-inverted-stencil-buffer"])
      });
    }
  